import { VENDOR_LOGIN_STATES } from '../../reducers/uiReducer'
import { authenticatedSelector } from '../../reducers/userReducer'

export function isVendorLoggedInSelector(user, ui) {
  return (
    authenticatedSelector(user) &&
    ui.vendorLoginState === VENDOR_LOGIN_STATES.SUCCEEDED
  )
}

export function memberIdSelector(user) {
  return user.member_id
}

export function memberOrGuestIdSelector(user, sms) {
  return memberIdSelector(user) || sms.guestId
}

export function purchaseResultSelector(tapPay) {
  return tapPay.currentOrder
}
